define('v3/Common/Bindings/ContentEditable.Binding',['knockout', 'jquery'], function (ko, $) {
	var whitelistKeyCodes = [8, 46, 35, 36, 37, 38, 39, 40];

	ko.bindingHandlers.contentEditable = {
		init: function (element, valueAccessor, allBindingsAccessor) {
			var $element = $(element);
			var value = ko.unwrap(valueAccessor());
			var text = allBindingsAccessor().value;
			var onEnter = value.onEnter;

			$element.data('originalText', text());

			$element
				.text(value.title())
				.on('input', function () {
					var valueText = $element.text();

					// Strip any Copy-pasted HTML
					if ($element.children().length > 0) {
						$element.text(valueText);
					}

					if (value.maxLength) {
						if (valueText.length > value.maxLength) {
							valueText = valueText.substr(0, value.maxLength);
							$element.text(valueText);
						}
					}

					if (this.isContentEditable && ko.isWriteableObservable(text)) {
						text(valueText);
					}
				})
				.on('keyup keydown', function (e) {
					var valueText = $element.text();

					if (value.stripEnter && e.keyCode === 13) {
						e.preventDefault();
					}

					if (onEnter && e.keyCode === 13) {
						onEnter(null, e);
					}

					if (value.maxLength) {
						if (whitelistKeyCodes.indexOf(e.keyCode) === -1 && !e.ctrlKey) {
							if (valueText.length === value.maxLength) {
								e.preventDefault();
							}

							if (valueText.length > value.maxLength) {
								valueText = valueText.substr(0, value.maxLength);
								$element.text(valueText);
								e.preventDefault();
							}
						}
					}

					if (this.isContentEditable && ko.isWriteableObservable(text)) {
						text(valueText);
					}
				});
		},
		update: function (element, valueAccessor) {
			var value = ko.unwrap(valueAccessor());
			var editActive = value.editActive;
			var currentText = value.title();

			if (!editActive) {
				$(element).text(currentText);
			}
		}
	};
});

